module.exports = __webpack_public_path__ + "static/media/banner.ec8c6223.png";